

const urls = {
    DAILY_PIPE: 'stock-management/daily-pipe',
    DAILY_PIPE_CREATE_NEW_DAY: 'stock-management/daily-pipe-create-new-day',
    STOCK_MANAGEMENT_DAILY_TANK: 'stock-management/daily-tank',
    STOCK_MANAGEMENT_DAILY_TANK_AUTO: 'stock-management/daily-tank-auto',
    STOCK_MANAGEMENT_DAILY_TANK_MANUAL: 'stock-management/daily-tank-manual',
    STOCK_MANAGEMENT_DAILY_TANK_MANUAL_LOCKED: 'stock-management/daily-tank-manual-locked',
    STOCK_MANAGEMENT_DAILY_TANK_MANUAL_CALCULATION: 'stock-management/daily-stock-manual-calculation',
    STOCK_MANAGEMENT_DAILY_TANK_CALCULATION: 'stock-management/daily-stock-calculation',
    EXCLUDED_TANKS: 'stock-management/excluded-tanks',
    STOCK_MANAGEMENT_DAILY_TANK_CREATE_NEW_MONTH: 'stock-management/create-new-month',
    DELTA_STOCK_REPORT: 'stock-management/delta-stock-report',
    STOCK_MANAGEMENT_DAILY_LOCKED: 'stock-management-daily-locked',

    IMPORT_LIMS: 'stock-management/lims-import',
    IMPORT_MTS: 'stock-management/mts-import',
    MTS: 'stock-management/mts',
    EXPORT_MTS: 'stock-management/mts-export',
    IMPORT_PI: 'stock-management/pi-import',
    IMPORT_EQUIPMENT_OPERATION: 'stock-management/equipment-operation-import',

    STOCK_MANAGEMENT_DAILY_EXPORT_PLANT: 'stock-management-export-daily',
    STOCK_MANAGEMENT_DAILY_EXPORT_FORWARD: 'stock-management-export-forward',
    STOCK_MANAGEMENT_DAILY_EXPORT_PI: 'stock-management-stock-to-pi',
    STOCK_MANAGEMENT_DAILY_EXPORT_ALL: 'stock-management-export-all',

    STOCK_MANAGEMENT_MONTHLY_EXPORT: 'stock-management-export-monthly',

    STOCK_MANAGEMENT_CREATE_LOCKED_ASSET: 'stock-management/create-locked-asset',
    STOCK_MANAGEMENT_DAILY_LOCKED_LOCK_TANK_BY_DAILY_TANK_ID: 'stock-management-daily-locked/lock-tank-by-daily-tank',

    STOCK_MANAGEMENT_SEND_DELTA_STOCK_BY_EMAIL: 'stock-management-send-delta-email',

    STOCK_MANAGEMENT_INVENTORY_REGISTRY: 'stock-management-inventory/registry',
    STOCK_MANAGEMENT_INVENTORY_REGISTRY_EXPORT: 'stock-management-inventory/registry-export',
    STOCK_MANAGEMENT_INVENTORY_REGISTRY_VALIDATION: 'stock-management-inventory/registry-item-validation',
    STOCK_MANAGEMENT_INVENTORY_REGISTRY_CALCULATE_STOCK: 'stock-management-inventory/registry-calculate-stock',
    STOCK_MANAGEMENT_INVENTORY_REGISTRY_UPDATE_BY_OSI_PI: 'stock-management-inventory/registry-update-by-osipi',
    STOCK_MANAGEMENT_INVENTORY_REGISTRY_LOCK_UNLOCK_ITEM: 'stock-management-inventory/registry-item-lock-unlok',
    STOCK_MANAGEMENT_INVENTORY_REGISTRY_PUBLISH: 'stock-management-inventory/registry-publish',

    STOCK_MANAGEMENT_INVENTORY_ELABORATION: 'stock-management-inventory/elaboration',
    STOCK_MANAGEMENT_INVENTORY_ELABORATION_LAST: 'stock-management-inventory/elaboration-last',
    STOCK_MANAGEMENT_INVENTORY_ELABORATION_NEXT_STAGE: 'stock-management-inventory/elaboration-next-stage',

    STOCK_TAKE: 'stock-take',
    STOCK_TAKE_HEADER: 'stock-take-header',
    STOCK_TAKE_COMBO: 'stock-take-header-combo',
    STOCK_TAKE_TANK: 'stock-take-tank',
    STOCK_TAKE_TANK_LITE: 'stock-take-tank-lite',
    STOCK_TAKE_HEADER_PROMOTE_TO_TANK_SELECTION_REV: 'stock-take-header-promote-to-tank-selection-revision',
    STOCK_TAKE_HEADER_CONFIRM_TANK_BY_PLANT_CODE: 'stock-take-header-confirm-tanks',
    STOCK_TAKE_IMPORT_PI: 'stock-take-tank-import-pi',
    STOCK_TAKE_MEASURES: 'stock-take-tank-measures',
    STOCK_TAKE_MASSIVE_SCHEDULE: 'stock-take-tank-massive-schedule',
    STOCK_TAKE_TANK_SCHEDULING_UPDATE: 'stock-take-tank-scheduling-update',
    STOCK_TAKE_IMPORT_LIMS: 'stock-take-tank-import-lims',
    STOCK_TAKE_NOTE_UPDATE: 'stock-take-tank-note-update',
    STOCK_TAKE_TANK_CONFIRM_MEASURE: 'stock-take-tank-confirm-measure',
    STOCK_TAKE_CREATE_RESCHEDULE_REQUEST_TANK: 'stock-take-tank-create-reschedule-request',
    STOCK_TAKE_APPROVE_REJECT_RESCHEDULE_REQUEST_TANK: 'stock-take-tank-approve-reject-reschedule-request',
    STOCK_TALE_RESCHEDULE_REQUESTS_TANK: 'stock-take-tank-get-reschedule-requests',
    STOCK_TAKE_MASSIVE_CONFIRM_MEASURES: 'stock-take-tank-massive-confirm-measure',
    STOCK_TAKE_IMPORT_LIMS_MASSIVE: 'stock-take-tank-massive-import-lims',
    STOCK_TAKE_TANK_MASSIVE_IMPORT_STOCK_MANAGEMENT: 'stock-take-tank-massive-import-stock-management',
    STOCK_TAKE_REPORT_EXCEL: 'inventory-export-excel',
    EXPORT_INVENTORY_DELTA: 'inventory-export-delta-inventory',
    STOCK_MANAGEMENT_DISCHARGE_DROPS_REPORT: 'stock-management/discharge-drops-report',
    STOCK_MANAGEMENT_DISCHARGE_DROPS_REPORT_EXCEL: 'stock-management/discharge-drops-report-excel'
}

import genericService from '../genericService';

export default {
    async dailyPipeCreateNewDay(callback){
        await genericService.post(urls.DAILY_PIPE_CREATE_NEW_DAY, {}).then(callback);
    },
    async saveStockManagementDailyTank(body, callback){
        await genericService.put(urls.STOCK_MANAGEMENT_DAILY_TANK, body).then(callback);
    },
    async createStockManagementDailyTank(body, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_DAILY_TANK, body).then(callback);
    },
    async createStockManagementDailyPipe(body, callback){
        await genericService.post(urls.DAILY_PIPE, body).then(callback);
    },
    async deleteStockManagementDailyTank(body, callback){
        await genericService.delete(urls.STOCK_MANAGEMENT_DAILY_TANK, body).then(callback);
    },
    async getStockManagementDailyTankAuto(body, callback){
        await genericService.get(urls.STOCK_MANAGEMENT_DAILY_TANK_AUTO, body).then(callback);
    },
    async getStockManagementDailyTankManual(body, callback){
        await genericService.get(urls.STOCK_MANAGEMENT_DAILY_TANK_MANUAL, body).then(callback);
    },
    async calculateStockManagementDailyTank(body, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_DAILY_TANK_MANUAL_CALCULATION, body).then(callback);
    },
    async reimportStockManagementDailyTank(referenceDate, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_DAILY_TANK_CALCULATION + '?referenceDate=' + referenceDate, {}).then(callback);
    },
    async getExcludedTanks(callback){
        await genericService.get(urls.EXCLUDED_TANKS, {}).then(callback);
    },
    async deleteExcludedTanks(id, callback){
        await genericService.delete(urls.EXCLUDED_TANKS, id).then(callback);
    },
    async createExcludedTank(body, callback){
        await genericService.post(urls.EXCLUDED_TANKS, body).then(callback);
    },
    async getDailyLocked(body, callback){
        await genericService.get(urls.STOCK_MANAGEMENT_DAILY_LOCKED, body).then(callback);
    },
    async updateDailyLocked(body, callback){
        await genericService.put(urls.STOCK_MANAGEMENT_DAILY_LOCKED, body).then(callback);
    },
    async deleteDailyLocked(id, callback){
        await genericService.delete(urls.STOCK_MANAGEMENT_DAILY_LOCKED, id).then(callback);
    },
    async calculateNewMonth(body, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_DAILY_TANK_CREATE_NEW_MONTH, body).then(callback);
    },
    async printDeltaStockReport(body, callback){
        await genericService.dowloadFile(urls.DELTA_STOCK_REPORT, body).then(callback);
    },
    async importLims(referenceDate, callback){
        await genericService.post(urls.IMPORT_LIMS + '?referenceDate=' + referenceDate, {}).then(callback);
    },
    async importMts(referenceDate, callback){
        await genericService.post(urls.IMPORT_MTS + '?referenceDate=' + referenceDate, {}).then(callback);
    },
    async importPi(referenceDate, callback){
        await genericService.post(urls.IMPORT_PI + '?referenceDate=' + referenceDate, {}).then(callback);
    },
    async importEquipmentOperation(referenceDate, callback){
        await genericService.post(urls.IMPORT_EQUIPMENT_OPERATION + '?referenceDate=' + referenceDate, {}).then(callback);
    },
    async exportStockAll(body, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_DAILY_EXPORT_ALL, body).then(callback);
    },
    async exportStockStock(body, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_DAILY_EXPORT_PLANT, body).then(callback);
    },
    async exportStockForward(body, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_DAILY_EXPORT_FORWARD, body).then(callback);
    },
    async exportStockPi(body, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_DAILY_EXPORT_PI, body).then(callback);
    },
    async exportStockMonthly(body, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_MONTHLY_EXPORT, body).then(callback);
    },
    async createLockedAssetRecord(referenceDate, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_CREATE_LOCKED_ASSET + '?referenceDate=' + referenceDate, {}).then(callback);
    },
    async lockTankByDailyTank(data, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_DAILY_LOCKED_LOCK_TANK_BY_DAILY_TANK_ID, data).then(callback);
    },
    async unlockTankByDailyTankId(id, callback){
        await genericService.delete(urls.STOCK_MANAGEMENT_DAILY_LOCKED_LOCK_TANK_BY_DAILY_TANK_ID, id).then(callback);
    },
    async sendDeltaStockByEmail(params, callback){
        await genericService.get(urls.STOCK_MANAGEMENT_SEND_DELTA_STOCK_BY_EMAIL, params).then(callback);
    },
    async addMtsDataItem(body, callback){
        await genericService.post(urls.MTS, body).then(callback);
    },
    async updateMtsDataItem(body, callback){
        await genericService.put(urls.MTS, body).then(callback);
    },
    async importMts(referenceDate, callback){
        await genericService.post(urls.IMPORT_MTS + '?referenceDate=' + referenceDate).then(callback);
    },
    async exportMtsToManualDailyStock(referenceDate, callback){
        await genericService.post(urls.EXPORT_MTS + '?referenceDate=' + referenceDate).then(callback);
    },
    async getInventoryRegistryLiquidData(params, callback){
        await genericService.get(urls.STOCK_MANAGEMENT_INVENTORY_REGISTRY + '?extractionType=PROD', params).then(callback);
    },
    async getInventoryRegistryGasData(params, callback){
        await genericService.get(urls.STOCK_MANAGEMENT_INVENTORY_REGISTRY + '?extractionType=GAS', params).then(callback);
    },
    async exportInventoryRegistryExcel(body, callback){
        await genericService.dowloadFile(urls.STOCK_MANAGEMENT_INVENTORY_REGISTRY_EXPORT, body).then(callback);
    },
    async updateInventoryRegistryItem(body, callback){
        await genericService.put(urls.STOCK_MANAGEMENT_INVENTORY_REGISTRY, body).then(callback);
    },
    async createNewInventory(body, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_INVENTORY_REGISTRY, body).then(callback);
    },
    async publishInventory(body, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_INVENTORY_REGISTRY_PUBLISH, body).then(callback);
    },
    async validateInventoryRegistryItems(body, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_INVENTORY_REGISTRY_VALIDATION + '?validate=' + body.validate, body.itemsList).then(callback);
    },
    async lockUnlockInventoryRegistryItems(body, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_INVENTORY_REGISTRY_LOCK_UNLOCK_ITEM, body).then(callback);
    },
    async updateInventoryRegistryItemsByOsiPi(body, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_INVENTORY_REGISTRY_UPDATE_BY_OSI_PI, body).then(callback);
    },
    async calculateInventoryRegistryStock(body, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_INVENTORY_REGISTRY_CALCULATE_STOCK, body).then(callback);
    },
    async getStockManagementInventoryLastElaboration(params, callback){
        await genericService.get(urls.STOCK_MANAGEMENT_INVENTORY_ELABORATION_LAST, params).then(callback);
    },
    async getStockManagementInventoryElaborationLog(id, callback){
        await genericService.getItem(urls.STOCK_MANAGEMENT_INVENTORY_ELABORATION, id).then(callback);
    },
    async startNewInventoryElaboration(body, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_INVENTORY_ELABORATION, body).then(callback);
    },
    async processNextInventoryElaborationStage(id, callback){
        await genericService.post(urls.STOCK_MANAGEMENT_INVENTORY_ELABORATION_NEXT_STAGE + '?elaborationId=' + id, null).then(callback);
    },
    async abortInventoryElaboration(id, callback){
        await genericService.delete(urls.STOCK_MANAGEMENT_INVENTORY_ELABORATION, id).then(callback);
    },
    async createStockTake(body, callback){
        await genericService.post(urls.STOCK_TAKE, body).then(callback);
    },
    async getStockTakeHeader(id, callback){
        await genericService.getItem(urls.STOCK_TAKE_HEADER, id).then(callback);
    },
    async getStockTakeCombo(callback){
        await genericService.get(urls.STOCK_TAKE_COMBO).then(callback);
    },
    async updateStockTakeTankLite(body, callback){
        await genericService.put(urls.STOCK_TAKE_TANK_LITE, body).then(callback);
    },
    async getStockTakeTank(body, callback){
        await genericService.get(urls.STOCK_TAKE_TANK, body).then(callback);
    },
    async promoteStockTakeToTankSelectionRevision(body, callback){
        await genericService.put(urls.STOCK_TAKE_HEADER_PROMOTE_TO_TANK_SELECTION_REV, body).then(callback);
    },
    async confirmTankStockTakeByPlantCode(body, callback){
        await genericService.put(urls.STOCK_TAKE_HEADER_CONFIRM_TANK_BY_PLANT_CODE, body).then(callback);
    },
    async massiveScheduleTankStockTake(body, callback){
        await genericService.put(urls.STOCK_TAKE_MASSIVE_SCHEDULE, body).then(callback);
    },
    async updateSchedulingTankStockTake(body, callback){
        await genericService.put(urls.STOCK_TAKE_TANK_SCHEDULING_UPDATE, body).then(callback);
    },
    async updateMeasuresStockTake(body, callback){
        await genericService.put(urls.STOCK_TAKE_MEASURES, body).then(callback);
    },
    async importPiStockTake(body,callback){
        await genericService.put(urls.STOCK_TAKE_IMPORT_PI, body).then(callback);
    },
    async importLims(body,callback){
        await genericService.put(urls.STOCK_TAKE_IMPORT_LIMS, body).then(callback);
    },
    async updateNoteTank(body,callback){
        await genericService.put(urls.STOCK_TAKE_NOTE_UPDATE, body).then(callback);
    },
    async updateConfirmMeasureTank(body,callback){
        await genericService.put(urls.STOCK_TAKE_TANK_CONFIRM_MEASURE, body).then(callback);
    },
    async createRescheduleRequestTank(body, callback){
        await genericService.post(urls.STOCK_TAKE_CREATE_RESCHEDULE_REQUEST_TANK, body).then(callback);
    },
    async approveRejectRescheduleRequestTank(body, callback){
        await genericService.post(urls.STOCK_TAKE_APPROVE_REJECT_RESCHEDULE_REQUEST_TANK, body).then(callback);
    },    
    async getRescheduleRequestTank(params,callback){
        await genericService.get(urls.STOCK_TALE_RESCHEDULE_REQUESTS_TANK, params).then(callback);
    },
    async massiveConfirmMeasuresTankStockTake(body, callback){
        await genericService.putNoId(urls.STOCK_TAKE_MASSIVE_CONFIRM_MEASURES + '/' + body.id + '?schedulingDate=' + body.schedulingDate, null).then(callback);
    },
    async exportInventoryReportDeltaExcel(body, callback){
        await genericService.dowloadFile(urls.EXPORT_INVENTORY_DELTA, body).then(callback);
    },
    async importLimsMassive(body,callback){
        await genericService.put(urls.STOCK_TAKE_IMPORT_LIMS_MASSIVE, body).then(callback);
    },
    async importStockManagementTankMassive(body,callback){
        await genericService.put(urls.STOCK_TAKE_TANK_MASSIVE_IMPORT_STOCK_MANAGEMENT, body).then(callback);
    },
    async exportStockTakeReportExcel(body, callback){
        await genericService.dowloadFile(urls.STOCK_TAKE_REPORT_EXCEL, body).then(callback);
    },
    async getDischargeDropsReport(body, callback){
        await genericService.get(urls.STOCK_MANAGEMENT_DISCHARGE_DROPS_REPORT, body).then(callback);
    },
    async getDischargeDropsReportExcel(body, callback){
        await genericService.dowloadFile(urls.STOCK_MANAGEMENT_DISCHARGE_DROPS_REPORT_EXCEL, body).then(callback);
    }
}